export const COUNTRIES = [
  { code: 'US', name: 'United States', dialCode: 1 },
  { code: 'GB', name: 'United Kingdom', dialCode: 44 },
  { code: 'CA', name: 'Canada', dialCode: 1 },
  { code: 'AU', name: 'Australia', dialCode: 61 },
  { code: 'DE', name: 'Germany', dialCode: 49 },
  { code: 'FR', name: 'France', dialCode: 33 },
  { code: 'IN', name: 'India', dialCode: 91 },
  { code: 'CN', name: 'China', dialCode: 86 },
  { code: 'JP', name: 'Japan', dialCode: 81 },
  { code: 'BR', name: 'Brazil', dialCode: 55 },
  { code: 'MX', name: 'Mexico', dialCode: 52 },
  { code: 'IT', name: 'Italy', dialCode: 39 },
  { code: 'ES', name: 'Spain', dialCode: 34 },
  { code: 'NL', name: 'Netherlands', dialCode: 31 },
  { code: 'SE', name: 'Sweden', dialCode: 46 },
  { code: 'CH', name: 'Switzerland', dialCode: 41 },
  { code: 'NO', name: 'Norway', dialCode: 47 },
  { code: 'DK', name: 'Denmark', dialCode: 45 },
  { code: 'FI', name: 'Finland', dialCode: 358 },
  { code: 'IE', name: 'Ireland', dialCode: 353 },
  { code: 'AT', name: 'Austria', dialCode: 43 },
  { code: 'BE', name: 'Belgium', dialCode: 32 },
  { code: 'PT', name: 'Portugal', dialCode: 351 },
  { code: 'GR', name: 'Greece', dialCode: 30 },
  { code: 'PL', name: 'Poland', dialCode: 48 },
  { code: 'CZ', name: 'Czech Republic', dialCode: 420 },
  { code: 'RO', name: 'Romania', dialCode: 40 },
  { code: 'HU', name: 'Hungary', dialCode: 36 },
  { code: 'RU', name: 'Russia', dialCode: 7 },
  { code: 'ZA', name: 'South Africa', dialCode: 27 },
  { code: 'KR', name: 'South Korea', dialCode: 82 },
  { code: 'SG', name: 'Singapore', dialCode: 65 },
  { code: 'HK', name: 'Hong Kong', dialCode: 852 },
  { code: 'TW', name: 'Taiwan', dialCode: 886 },
  { code: 'NZ', name: 'New Zealand', dialCode: 64 },
  { code: 'IL', name: 'Israel', dialCode: 972 },
  { code: 'AE', name: 'United Arab Emirates', dialCode: 971 },
  { code: 'SA', name: 'Saudi Arabia', dialCode: 966 },
  { code: 'TR', name: 'Turkey', dialCode: 90 },
  { code: 'EG', name: 'Egypt', dialCode: 20 },
  { code: 'NG', name: 'Nigeria', dialCode: 234 },
  { code: 'KE', name: 'Kenya', dialCode: 254 },
  { code: 'TH', name: 'Thailand', dialCode: 66 },
  { code: 'MY', name: 'Malaysia', dialCode: 60 },
  { code: 'PH', name: 'Philippines', dialCode: 63 },
  { code: 'ID', name: 'Indonesia', dialCode: 62 },
  { code: 'VN', name: 'Vietnam', dialCode: 84 },
  { code: 'PK', name: 'Pakistan', dialCode: 92 },
  { code: 'BD', name: 'Bangladesh', dialCode: 880 },
  { code: 'LK', name: 'Sri Lanka', dialCode: 94 },
  { code: 'AR', name: 'Argentina', dialCode: 54 },
  { code: 'CL', name: 'Chile', dialCode: 56 },
  { code: 'CO', name: 'Colombia', dialCode: 57 },
  { code: 'PE', name: 'Peru', dialCode: 51 },
  { code: 'VE', name: 'Venezuela', dialCode: 58 },
  { code: 'UA', name: 'Ukraine', dialCode: 380 },
  { code: 'BG', name: 'Bulgaria', dialCode: 359 },
  { code: 'HR', name: 'Croatia', dialCode: 385 },
  { code: 'SK', name: 'Slovakia', dialCode: 421 },
  { code: 'LT', name: 'Lithuania', dialCode: 370 },
  { code: 'LV', name: 'Latvia', dialCode: 371 },
  { code: 'EE', name: 'Estonia', dialCode: 372 },
  { code: 'IS', name: 'Iceland', dialCode: 354 },
  { code: 'LU', name: 'Luxembourg', dialCode: 352 },
  { code: 'MT', name: 'Malta', dialCode: 356 },
  { code: 'CY', name: 'Cyprus', dialCode: 357 },
  { code: 'QA', name: 'Qatar', dialCode: 974 },
  { code: 'KW', name: 'Kuwait', dialCode: 965 },
  { code: 'BH', name: 'Bahrain', dialCode: 973 },
  { code: 'OM', name: 'Oman', dialCode: 968 },
  { code: 'JO', name: 'Jordan', dialCode: 962 },
  { code: 'LB', name: 'Lebanon', dialCode: 961 },
  { code: 'GH', name: 'Ghana', dialCode: 233 },
  { code: 'TZ', name: 'Tanzania', dialCode: 255 },
  { code: 'UG', name: 'Uganda', dialCode: 256 },
  { code: 'MA', name: 'Morocco', dialCode: 212 },
  { code: 'TN', name: 'Tunisia', dialCode: 216 },
  { code: 'JM', name: 'Jamaica', dialCode: 1876 },
  { code: 'TT', name: 'Trinidad and Tobago', dialCode: 1868 },
  { code: 'PA', name: 'Panama', dialCode: 507 },
  { code: 'CR', name: 'Costa Rica', dialCode: 506 },
  { code: 'EC', name: 'Ecuador', dialCode: 593 },
  { code: 'UY', name: 'Uruguay', dialCode: 598 },
  { code: 'PY', name: 'Paraguay', dialCode: 595 },
  { code: 'BO', name: 'Bolivia', dialCode: 591 },
  { code: 'DO', name: 'Dominican Republic', dialCode: 1809 },
  { code: 'GT', name: 'Guatemala', dialCode: 502 },
  { code: 'HN', name: 'Honduras', dialCode: 504 },
  { code: 'SV', name: 'El Salvador', dialCode: 503 },
  { code: 'NI', name: 'Nicaragua', dialCode: 505 },
  { code: 'CU', name: 'Cuba', dialCode: 53 },
];

export const PRICING_PLANS = [
  {
    name: 'Essentials',
    price: '$45',
    suffix: '+ Federal Filing Fee',
    recommended: false,
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured',
    ],
    note: 'Govt. filing fee not included',
  },
  {
    name: 'Enhanced',
    price: '$149',
    suffix: '+ Federal Filing Fee',
    recommended: false,
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
    ],
    note: 'Govt. filing fee not included',
  },
  {
    name: 'Deluxe',
    price: '$299',
    suffix: '+ Federal Filing Fee',
    recommended: true,
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
    ],
    note: 'Govt. filing fee not included',
  },
  {
    name: 'Platinum',
    price: '$349',
    suffix: '+ Federal Filing Fee',
    recommended: false,
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      'High Approval Rate',
      'Comprehensive Search Report',
      'High Priority Service',
      'Cease & Desist Letter',
    ],
    note: 'Govt. filing fee not included',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Marcus Thompson',
    role: 'CEO, TechVault Inc.',
    quote: 'AmericanTrademark Firm made the entire trademark registration process seamless. Their team handled everything professionally, and I had my trademark secured in record time. Highly recommend their service to any business owner.',
  },
  {
    name: 'Sarah Mitchell',
    role: 'Founder, Bloom Cosmetics',
    quote: 'I was overwhelmed by the trademark process until I found AmericanTrademark Firm. They walked me through every step, conducted a thorough search, and filed my application flawlessly. Outstanding customer service from start to finish.',
  },
  {
    name: 'David Chen',
    role: 'CTO, NovaByte Solutions',
    quote: 'Protecting our software brand was crucial. AmericanTrademark Firm provided expert guidance on trademark classes and filing strategies. The dedicated case manager kept us informed throughout the entire process.',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Owner, Artisan Bakehouse',
    quote: 'As a small business owner, I needed affordable trademark protection. AmericanTrademark Firm offered competitive pricing without compromising on quality. My brand is now legally protected and I have peace of mind.',
  },
  {
    name: 'James Walker',
    role: 'Director, Apex Consulting',
    quote: 'The team at AmericanTrademark Firm is incredibly knowledgeable. They identified potential conflicts early in the process and adjusted our filing strategy accordingly. Professional, responsive, and results-driven.',
  },
  {
    name: 'Rachel Kim',
    role: 'VP Marketing, Luxe Interiors',
    quote: 'We needed trademark protection across multiple product lines and AmericanTrademark Firm delivered. Their comprehensive search saved us from a potential conflict we never would have found on our own. Exceptional service.',
  },
  {
    name: 'Daniel Foster',
    role: 'Founder, GreenPath Energy',
    quote: 'From our initial consultation to the final approval, AmericanTrademark Firm was transparent, efficient, and incredibly thorough. The Deluxe package was worth every penny for the peace of mind it provided.',
  },
  {
    name: 'Olivia Grant',
    role: 'CEO, NovaStar Media',
    quote: 'I have used other trademark services before but none compare to the level of attention AmericanTrademark Firm provides. They caught a potential issue early and resolved it before it became a problem. True professionals.',
  },
  {
    name: 'Michael Rivera',
    role: 'Partner, Summit Legal Group',
    quote: 'As a legal professional myself, I appreciate the quality of work AmericanTrademark Firm delivers. Their filings are thorough, their communication is excellent, and their turnaround time is impressive.',
  },
];

export const PROCESS_STEPS = [
  {
    step: 1,
    title: 'Submit Your Application',
    description: 'Fill out our streamlined application form with your trademark details. Our team reviews your submission and begins a comprehensive search to identify potential conflicts before filing.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop',
  },
  {
    step: 2,
    title: 'Expert Review & Filing',
    description: 'Our trademark specialists review your application, prepare all necessary documentation, and file your trademark with the USPTO. We handle every detail to maximize your approval chances.',
    image: 'https://images.unsplash.com/photo-1763729805496-b5dbf7f00c79?w=600&h=400&fit=crop',
  },
  {
    step: 3,
    title: 'Trademark Secured',
    description: 'Once approved, your trademark is officially registered. We provide complete documentation and offer ongoing monitoring to protect your brand from potential infringement.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop',
  },
];

export const FAQ_DATA = [
  {
    question: 'What is a trademark and why do I need one?',
    answer: 'A trademark is a legally registered symbol, word, or phrase that identifies and distinguishes your goods or services. It provides exclusive rights to use that mark in commerce, prevents others from using similar marks, and builds brand recognition and trust with your customers.',
  },
  {
    question: 'How long does the trademark registration process take?',
    answer: 'The USPTO typically takes 8 to 12 months to process a trademark application. However, timelines can vary depending on the complexity of your application and whether any office actions are issued. Our team works to expedite the process wherever possible.',
  },
  {
    question: 'What can be trademarked?',
    answer: 'You can trademark business names, logos, slogans, product names, sounds, colors, and even packaging designs. The key requirement is that the mark must be distinctive and used in commerce to identify your goods or services.',
  },
  {
    question: 'Do I need a trademark search before filing?',
    answer: 'Yes, a comprehensive trademark search is highly recommended. It helps identify existing trademarks that may conflict with yours, reducing the risk of rejection and potential legal disputes. Our search services examine federal, state, and common law databases.',
  },
  {
    question: 'What is the cost of trademark registration?',
    answer: 'Our service fees start at $45 plus the USPTO filing fee. We offer multiple packages tailored to different needs, from basic filing to comprehensive protection with monitoring and dedicated case management.',
  },
  {
    question: 'How long does a trademark last?',
    answer: 'A registered trademark can last indefinitely, as long as you continue to use it in commerce and file the required maintenance documents. The first maintenance filing is due between the 5th and 6th year after registration, and renewals are required every 10 years.',
  },
];

export const SERVICE_MENU = [
  {
    category: 'Trademark Services',
    services: [
      { slug: 'register-your-trademark', title: 'Register Your Trademark' },
      { slug: 'clearance-search-services', title: 'Clearance Search Services' },
      { slug: 'trademark-ownership-transfers', title: 'Trademark Ownership Transfers' },
      { slug: 'submission-of-statements-of-use', title: 'Submission of Statements of Use' },
      { slug: 'trademark-office-actions', title: 'Support for Trademark Office Actions' },
      { slug: 'trademark-monitoring', title: 'Active Monitoring for Infringement' },
      { slug: 'file-ttab-petition', title: 'File TTAB Petition' },
    ],
  },
  {
    category: 'Company Formation Services',
    services: [
      { slug: 'limited-liability-company', title: 'Limited Liability Company' },
      { slug: 'c-corporation', title: 'C Corporation' },
      { slug: 's-corporation', title: 'S Corporation' },
      { slug: 'non-profit', title: 'Non-Profit' },
    ],
  },
  {
    category: 'Copyright Services',
    services: [
      { slug: 'register-your-copyright', title: 'Register Your Copyright' },
      { slug: 'copyright-enforcement', title: 'Copyright Enforcement Assistance' },
      { slug: 'copyright-transfers-licensing', title: 'Copyright Transfers & Licensing' },
      { slug: 'copyright-legal-representation', title: 'Legal Representation for Copyright' },
      { slug: 'copyright-portfolio-management', title: 'Copyright Portfolio Management' },
      { slug: 'dmca-compliance', title: 'Compliance with DMCA Act' },
    ],
  },
  {
    category: 'Patent Services',
    services: [
      { slug: 'patent-search', title: 'Search for Existing Patent' },
      { slug: 'patent-office-actions', title: 'Support for Patent Office Actions' },
      { slug: 'patent-application', title: 'Application Submission for Patent' },
      { slug: 'patent-legal-representation', title: 'Legal Representation for Patent' },
    ],
  },
  {
    category: 'Legal Services',
    services: [
      { slug: 'business-immigration-law', title: 'Business Immigration Law' },
      { slug: 'due-diligence', title: 'Due Diligence Process' },
      { slug: 'it-commercial-law', title: 'IT & Commercial Law' },
      { slug: 'partnerships-llps', title: 'Partnerships & LLPs' },
      { slug: 'data-protection-privacy', title: 'Data Protection & Privacy Law' },
    ],
  },
  {
    category: 'Additional Corporate Services',
    services: [
      { slug: 'amazon-brand-registry', title: 'Amazon Brand Registry in the US' },
      { slug: 'bookkeeping-service', title: 'Bookkeeping Service' },
      { slug: 'business-formation-services', title: 'Business Formation Services' },
      { slug: 'certificate-of-good-standing', title: 'Certificate of Good Standing' },
      { slug: 'company-dissolution', title: 'Company Dissolution' },
      { slug: 'company-name-change', title: 'Company Name Change' },
      { slug: 'company-renewal-services', title: 'Company Renewal Services' },
      { slug: 'issue-of-shares', title: 'Issue Of Shares' },
      { slug: 'nominee-director-secretarial', title: 'Nominee Director & Secretarial' },
      { slug: 'tax-advisory-filing', title: 'Tax Advisory & Filing' },
      { slug: 'transfer-of-shares', title: 'Transfer of Shares' },
      { slug: 'cfo-services', title: 'CFO Services' },
    ],
  },
];

export const STATS = [
  { value: '15,000+', label: 'Trademarks Filed' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '50+', label: 'Countries Served' },
  { value: '24/7', label: 'Expert Support' },
];

export const WHY_CHOOSE = [
  {
    title: 'Expert Legal Team',
    description: 'Our team of experienced trademark attorneys and IP specialists ensures your application is handled with precision and care.',
  },
  {
    title: 'Transparent Pricing',
    description: 'No hidden fees or surprises. Our pricing is clear, competitive, and designed to provide maximum value for your investment.',
  },
  {
    title: 'Fast Processing',
    description: 'We prioritize efficiency without compromising quality. Your application is prepared and filed promptly to minimize delays.',
  },
  {
    title: 'Dedicated Support',
    description: 'Every client receives personalized attention with a dedicated case manager who keeps you informed at every stage.',
  },
  {
    title: 'Comprehensive Protection',
    description: 'From initial search to ongoing monitoring, we provide end-to-end trademark protection for your brand.',
  },
  {
    title: 'Proven Track Record',
    description: 'Thousands of successful registrations and satisfied clients speak to our expertise and commitment to results.',
  },
];
